// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal[data-v-5fa0c528]{background-color:rgba(0,0,0,.5)}.close[data-v-5fa0c528]{top:14px;right:20px}.action-button.edit[data-v-5fa0c528]{margin-right:15px}.form[data-v-5fa0c528]{width:60%;position:relative;margin:30px auto}.form>.form-group[data-v-5fa0c528]{display:flex}.instructions[data-v-5fa0c528]{margin:1.41575em 0}", ""]);
// Exports
module.exports = exports;
